import { isAppDebugEnabled } from '@/utils/debug/debugEnv';

const MAX_DEPTH = 12;
const PLAIN_SKIP_KEYS = new Set(['__ob__', '_isVue', '_Ctor']);

export { isAppDebugEnabled } from '@/utils/debug/debugEnv';

/**
 * Vue 반응형·순환 참조를 제거한 plain 객체 (디버그 출력용)
 */
export function toPlainDebugValue(value, depth = 0, seen = new WeakSet()) {
  if (value === undefined) return undefined;
  if (value === null) return null;

  const t = typeof value;
  if (t === 'string' || t === 'number' || t === 'boolean' || t === 'bigint') {
    return value;
  }
  if (t === 'function') {
    return `[Function ${value.name || 'anonymous'}]`;
  }
  if (t === 'symbol') {
    return String(value);
  }
  if (value instanceof Error) {
    return { name: value.name, message: value.message, stack: value.stack };
  }
  if (depth >= MAX_DEPTH) {
    return '[MaxDepth]';
  }
  if (seen.has(value)) {
    return '[Circular]';
  }
  seen.add(value);

  if (Array.isArray(value)) {
    return value.map(item => toPlainDebugValue(item, depth + 1, seen));
  }

  const out = {};
  for (const key of Object.keys(value)) {
    if (PLAIN_SKIP_KEYS.has(key)) {
      continue;
    }
    try {
      const v = toPlainDebugValue(value[key], depth + 1, seen);
      if (v !== undefined) {
        out[key] = v;
      }
    } catch {
      out[key] = '[Unserializable]';
    }
  }
  return out;
}

/** 객체를 펼친 들여쓰기 JSON 문자열로 변환 */
export function formatExpandedDebugDetail(detail) {
  if (detail == null) {
    return '';
  }
  if (typeof detail === 'string') {
    return detail;
  }
  try {
    const plain = toPlainDebugValue(detail);
    return JSON.stringify(plain, null, 2);
  } catch {
    return String(detail);
  }
}

/**
 * 콘솔에 제목 + 펼친 JSON 본문으로 출력 (DevTools에서 클릭 없이 전체 확인)
 * @param {string} prefix 예: [MODULE-LIST-DEBUG]
 * @param {string} event
 * @param {unknown} [detail]
 */
export function logExpandedDebug(prefix, event, detail = null) {
  if (!isAppDebugEnabled()) {
    return;
  }
  console.log(`${prefix} ${event}`);
  if (detail == null) {
    return;
  }
  if (typeof detail === 'object' && !Array.isArray(detail) && Object.keys(detail).length === 0) {
    return;
  }
  console.log(formatExpandedDebugDetail(detail));
}

/** pi-console-bridge 전송용 — 객체를 펼친 텍스트로 직렬화 */
export function serializeArgsForBridge(args) {
  return args
    .map(a => {
      try {
        if (a instanceof Error) {
          return a.stack || a.message;
        }
        if (typeof a === 'object' && a !== null) {
          return formatExpandedDebugDetail(a);
        }
        return String(a);
      } catch {
        return '[unserializable]';
      }
    })
    .join('\n');
}
